import module from '@kendu/ui/module'
import './style.scss'

export class KdTableCellComponent {}

module.component('kdTableCell', {
  controller: KdTableCellComponent,
  restrict: 'E',
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-table/cell/component.js